import "./App.css";
import MainNavigator from "./Navigator/MainNavigator";
import TagManager from "react-gtm-module";
import ReactGA from "react-ga4";
import { TranslationProvider } from "./store/TranslationContext";
import ScrollToTop from "./ScrollToTop";
import { useEffect } from "react";

const TRACKING_ID = "G-QH842Q832S";

// Initialize analytics only once
const initializeAnalytics = () => {
	ReactGA.initialize(TRACKING_ID);

	const tagManagerArgs = {
		gtmId: "GTM-MN8J4FJC",
	};
	TagManager.initialize(tagManagerArgs);
};

function App() {
	useEffect(() => {
		// Initialize analytics after component mounts (non-blocking)
		initializeAnalytics();

		// Event delegation for submit buttons
		const handleClick = (event) => {
			const text = (event.target?.innerText || "").trim();

			if (text.includes("SUBMIT")) {
				ReactGA.event({
					action: "conversion",
					category: "Conversions",
					send_to: "AW-761375362/ZkzACN_HtvQYEILVhusC",
				});
			}
		};

		document.addEventListener("click", handleClick, { capture: true });

		return () => {
			document.removeEventListener("click", handleClick, { capture: true });
		};
	}, []);

	return (
		<TranslationProvider>
			<ScrollToTop />
			<MainNavigator />
		</TranslationProvider>
	);
}

export default App;